export default (value: string | number): string => {
  return value.toString().replace(/\s+/g, "");
};
